<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="96rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.viewDetails')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>
        <!--content-->
        <v-card-text>
          <p class="fs12">총 {{periodCnt}}차수가 검색되었습니다.</p>

          <v-divider class="mb-4"></v-divider>
          <div class="tbl-group line-ty tbl-fixed size-custom16">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer>
              <template v-slot:item.author="{ item }" >
                <div>
                  {{item.author}}
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn01 :btnText="t('message.confirm')" @click="dialog=false"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const dialog = defineModel()

//bind
const snackbar = ref(false)
const snackText = ref('')
const headers = ref([])
const items = ref([])
const periodCnt = ref(0)

//ui

//hook
onUpdated(() => {
  if(dialog.value)
    onClickSearch()
})

//function
function onClickSearch(){
  let params = storeRef.popupParams.value
  items.value = []

  BbsService.getMonitoringPeriodMemberCnt(params).then(
    (response) => {
      const memberArr = _.uniq(_.map(response.result, 'memberIdx'));
      const periodArr = _.uniq(_.map(response.result, 'monitoringUniq'));
      periodCnt.value = periodArr.length
      //header 셋팅
      headers.value = [
        { title: t('message.author'), key: 'author' },
        { title: t('message.monitoring')+' '+t('message.total'), key: 'monitoringTotal' },
        { title: t('message.safetyTalk')+' '+t('message.total'), key: 'safetyTalkTotal' },
      ]
      _.forEach(periodArr, function(val, key) {
          headers.value.push({title:val, key:val})
      })
      //맴버별 로우 셋팅
      let tempItems = []
      _.forEach(memberArr, function(val, key) {
        const tempMemberInfo = _.find(response.result, {memberIdx:val})
        let totalAnswerCnt = 0
        let totalTimelineCnt = 0
        let resultObj = {
          author: `${tempMemberInfo.memberName||t('message.noInfo')}(${tempMemberInfo.memberId||t('message.noInfo')}) / ${tempMemberInfo.posName||t('message.noInfo')} / ${tempMemberInfo.deptName||t('message.noInfo')}`,
          monitoringTotal: 0,
          safetyTalkTotal: 0,
        }
        _.forEach(periodArr, function(val2, key2) {
          const tempMemberInfo2 = _.find(response.result, {memberIdx:tempMemberInfo.memberIdx, monitoringUniq:val2})
          if(!utils.isEmpty(tempMemberInfo2)) {
            resultObj[val2] = tempMemberInfo2.answerCnt ? tempMemberInfo2.answerCnt : 0 + '/' + tempMemberInfo2.timelineCnt ? tempMemberInfo2.timelineCnt : 0
            totalAnswerCnt += tempMemberInfo2.answerCnt ? tempMemberInfo2.answerCnt : 0
            totalTimelineCnt += tempMemberInfo2.timelineCnt ? tempMemberInfo2.timelineCnt : 0
          }
        })
        resultObj.monitoringTotal = totalAnswerCnt
        resultObj.safetyTalkTotal = totalTimelineCnt
        tempItems.push(resultObj)
      })
      items.value = tempItems
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>


<style lang="scss">
</style>
